import { useCallback, useState } from "react";
import { parseEther } from "viem";
import { useBalance } from "wagmi";
import { ampli } from "../../ampli";
import { _CollectionType, TransactionType, } from "../../apollo/graphql.generated";
import { useOnChainTransaction } from "../../hooks/useOnChainTransaction";
export const useSwapCurrency = ({ walletAddress, fromChain, toChain, fromCurrency, toCurrency, value, onFinish, }) => {
    const [balanceError, setBalanceError] = useState("");
    const { error, startTransaction, buttonLabel, buttonLoading, clearError: clearTxError, } = useOnChainTransaction({
        collectionType: _CollectionType.OpenEdition,
        entityId: walletAddress !== null && walletAddress !== void 0 ? walletAddress : "",
        onFinish,
        refetchQueries: [],
        transactionType: TransactionType.EVM_SWAP_CURRENCY,
        actionLabel: `Swap`,
    });
    const { refetch: fetchBalance, isLoading: isLoadingBalance } = useBalance({
        address: walletAddress,
        cacheTime: 60000,
        enabled: false,
        token: (fromCurrency === null || fromCurrency === void 0 ? void 0 : fromCurrency.isNative)
            ? undefined
            : fromCurrency === null || fromCurrency === void 0 ? void 0 : fromCurrency.address,
        chainId: fromChain ? fromChain.chainId : undefined,
    });
    const handleSwap = useCallback(async () => {
        if (!fromChain ||
            !toChain ||
            !fromCurrency ||
            !toCurrency ||
            !value ||
            !walletAddress) {
            return;
        }
        const nativeBalance = await fetchBalance();
        if (nativeBalance.data &&
            value > parseFloat(nativeBalance.data.formatted)) {
            return setBalanceError(getBalanceError(nativeBalance.data.formatted));
        }
        setBalanceError("");
        await startTransaction({
            fromCurrencyAddress: fromCurrency.address,
            args: {
                address: toCurrency.address,
                chainId: fromChain.chainId,
                value: parseEther(value.toString()).toString(),
                args: "",
            },
            metadata: {
                amount: value.toString(),
                fromCurrencySymbol: fromCurrency.symbol,
                toCurrencySymbol: toCurrency.symbol,
                fromChain: fromChain.name,
                toChain: toChain.name,
                isWrapping: fromCurrency.isNative,
            },
        });
        if (ampli.isLoaded) {
            ampli.swapCurrencies({
                swapType: getUserAction({
                    fromChain,
                    toChain,
                    fromCurrency,
                    toCurrency,
                }),
                pagePath: location.pathname,
                tradedBack: `${fromChain.chainId}:${fromCurrency.symbol}`,
                tradedIn: `${toChain.chainId}:${toCurrency.symbol}`,
            });
        }
    }, [fromChain, toChain, value, fromCurrency, toCurrency, walletAddress]);
    return {
        handleSwap,
        error: error || balanceError,
        buttonLabel,
        buttonLoading: buttonLoading || isLoadingBalance,
        clearError: () => {
            setBalanceError("");
            clearTxError();
        },
        getUserAction,
    };
};
const getBalanceError = (balance) => `Insufficient balance. Your balance is ${parseFloat(balance).toFixed(5)}`;
const getUserAction = ({ fromChain, toChain, fromCurrency, toCurrency, }) => {
    if (fromChain.chainId === toChain.chainId) {
        return fromCurrency.isNative && !toCurrency.isNative ? "wrap" : "unwrap";
    }
    return "swap";
};
